/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import axios from 'axios';
import _ from 'lodash'

const getCookie = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

const setAxiosDefaults = () => {
    axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL || window._env_.REACT_APP_OPS_API_URL
    // axios.defaults.headers.common['Accept'] = 'application/json';
    // axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
    axios.defaults.method = 'POST';
    console.log('Axios defaults set', axios.defaults.method)
}

setAxiosDefaults();
// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    // Do something with response error
    const msg = _.get(error, 'response.data.msg', null)

    //logout isn't imported here, this is causing an error
    // if (msg === 'Expired Token' || msg === 'Event not allowed without valid token') {
    //     // Send user to login URL
    //     logout();
    // }
    return Promise.reject(error);
});

const custom = (config = {}, timeout) => {
    console.log("config ====", config);
    //config.data = config.data;
    config.url = axios.defaults.baseURL;
    return axios(config);
};

const addDoc = (data, config = {}) => {
    axios.defaults.baseURL = `${window._env_.REACT_APP_OPS_API_URL}?timeout=10000`;
    axios.defaults.headers.common.kxToken = getCookie('kxSupervisorToken');
    return axios(data, config);
};

const all = (requestArray) => {
    return axios.all(requestArray)
}
const post = (url = '', data = '', config = {}) => {
    return axios.post(url, data, config)
}

// data ===  { eventMessage , event type , event time}
const CustomPost = data => {
    let config = {}
    axios.defaults.baseURL = window._env_.REACT_APP_OPS_API_URL
    config.data = data
    axios.defaults.baseURL = window._env_.REACT_APP_OPS_API_URL
    return axios(config)
}



const get = (url = '', data = '', config = {}) => {
    config.params = data;
    config.method = "get";
    return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
    return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
    return axios.delete(url, config)
}

const HttpClient = {
    addDoc,
    custom,
    post,
    get,
    put,
    delete: del,
    all,
    setAxiosDefaults,
    CustomPost
}

export { HttpClient }
